/* global confirm */
import { asyncCallRoutePost } from '../../helpers/api';

/**
 * Class for handling all custom functionality on view order page (/my-account/view-order/123/)
 */
export class DeleteOrderButton {
	constructor( element ) {
		this.element = element;
		this.button = this.element.querySelector( '.js-qala-b2b-wholesale-delete-order-button-button' );
		this.orderId = element.getAttribute( 'data-order-id' );

		// Use the existing woocommerce-notices-wrapper is it exists, otherwise create a new one
		this.noticeElementWrapper = document.querySelector( '.woocommerce-notices-wrapper' );

		if ( this.noticeElementWrapper ) {
			this.noticeElement = document.createElement( 'div' );
			this.noticeElementWrapper.appendChild( this.noticeElement );
		}

		this.routeUrl = window.QalaB2bWholesale.deleteOrderRouteObj.routeUrl;
		this._wpnonce = window.QalaB2bWholesale.deleteOrderRouteObj._wpnonce;
	}

	/**
	 * Initialize the view order page with all needed callbacks
	 *
	 * @return {void}
	 */
	init() {
		this.setupDeleteButton();
	}

	/**
	 * Setup the save order button.
	 *
	 * @return {void}
	 */
	setupDeleteButton() {
		if ( ! this.setupDeleteButton ) {
			return;
		}

		this.button.addEventListener( 'click', this.deleteOrder.bind( this ) );
	}

	/**
	 * Delete the order.
	 *
	 * @return {void}
	 */
	async deleteOrder() {
		if ( ! this.orderId ) {
			return;
		}

		// Add confirmation dialog
		const confirmation = confirm( window.QalaB2bWholesale.translations.orderPageTranslations.deleteOrderConfirmation ); // eslint-disable-line no-alert

		if ( ! confirmation ) {
			return;
		}

		try {
			const response = await asyncCallRoutePost( this.routeUrl, this._wpnonce, {
				order_id: this.orderId,
			} );
			return this.processResponse( response );
		} catch ( e ) {
			this.processErrorResponse( e );
			return false;
		}
	}

	/**
	 * Start the request for validating customer email.
	 *
	 * @return {void}
	 */
	startValidating() {
		this.isValidationInProgress = true;
		this.saveOrderButtonElement.disabled = true;
		this.sendCustomerEmailButton.disabled = true;
		this.clearNotice();
	}

	/**
	 * End the request for validating customer email.
	 *
	 * @return {void}
	 */
	endValidating() {
		this.isValidationInProgress = false;
		this.saveOrderButtonElement.disabled = false;
		this.sendCustomerEmailButton.disabled = false;
	}

	/**
	 * Process the response from the server, assuming everything is ok (no server error)
	 *
	 * @param {Object} response
	 */
	processResponse( response ) {
		this.noticeElement.innerHTML = response.message;
		let isSuccess = false;

		if ( response?.data?.status && response.data.status === 200 ) {
			isSuccess = true;
		}

		if ( isSuccess ) {
			this.setSuccessNotice( response.message );

			// Redirect to the order page
			window.location.href = window.QalaB2bWholesale.draftOrdersPageUrl;
		} else {
			this.setErrorNotice( response.message );
		}
	}

	/**
	 * Process the error response from the server, happens if there is a server error (500)
	 *
	 * @return {void}
	 */
	processErrorResponse() {
		this.setErrorNotice( window.QalaB2bWholesale.text.unknownError );
	}

	/**
	 * Set the success notice.
	 *
	 * @param {string} text Text to set.
	 * @return {void}
	 */
	setSuccessNotice( text ) {
		if ( ! this.noticeElement ) {
			return;
		}
		this.noticeElement.hidden = false;
		this.noticeElement.innerHTML = text;
		this.noticeElement.classList.remove( 'woocommerce-error' );
		this.noticeElement.classList.add( 'woocommerce-message' );
		this.hideNoticeAfterDelay( this.noticeElement );
	}

	/**
	 * Set the error notice.
	 *
	 * @param {string} text Text to set.
	 * @return {void}
	 */
	setErrorNotice( text ) {
		if ( ! this.noticeElement ) {
			return;
		}

		this.noticeElement.hidden = false;
		this.noticeElement.innerHTML = text;
		this.noticeElement.classList.remove( 'woocommerce-message' );
		this.noticeElement.classList.add( 'woocommerce-error' );
	}

	/**
	 * Clear the notice.
	 *
	 * @return {void}
	 */
	clearNotice() {
		if ( ! this.noticeElement ) {
			return;
		}

		this.noticeElement.innerHTML = '';
		this.noticeElement.classList.remove( 'woocommerce-message' );
		this.noticeElement.classList.remove( 'woocommerce-error' );
	}

	/**
	 * Hide the notice after a delay.
	 *
	 * @param {Element} element
	 * @return {void}
	 */
	hideNoticeAfterDelay( element ) {
		setTimeout( () => {
			element.hidden = true;
		}, 5000 );
	}
}
